import type { MutableRefObject } from 'react';

import { useEffect } from 'react';

import type { EditorJsData } from '#/pages/document/editorjs-types';

export function useSyncEditorValueFromProp({
  editorRef,
  persistChainRef,
  latestValueRef,
  value,
}: {
  editorRef: MutableRefObject<any | null>;
  persistChainRef: MutableRefObject<Promise<unknown>>;
  latestValueRef: MutableRefObject<EditorJsData | null>;
  value?: EditorJsData | null;
}): void {
  useEffect(() => {
    if (!editorRef.current) return;
    persistChainRef.current = Promise.resolve();
    latestValueRef.current = value ?? { blocks: [] };
    void editorRef.current.isReady
      .then(() =>
        editorRef.current.render(
          (latestValueRef.current as any) ?? { blocks: [] },
        ),
      )
      .catch(() => {});
  }, [value]);
}
